export default function PrazoExecucao({ prazoExecucaoFmt, situacaoPrazo }) {

  const estilo = (situacaoPrazo) => {

    if (situacaoPrazo == 'vencida')
      return { background: 'red', color: 'white', animation: 'pulsar 2s infinite' }
    if (situacaoPrazo == '3dias')
      return { background: 'yellow', color: 'black' }
  }

  return (
    <span style={{ ...estilo(situacaoPrazo), borderRadius: 3, padding: '3px 7px' }}>{prazoExecucaoFmt}</span>
  )
}